// extracted by mini-css-extract-plugin
export var banner = "_34-0";
export var icon = "_34-1";
export var message = "_34-2";